import React from 'react';
import { To } from 'react-router-dom';
import AppLink, { AppLinkProps } from '../../common/AppLink';

export default ActivityCenterAuditLink;

export type ActivityCenterAuditLinkProps = Omit<AppLinkProps, 'to'> & {
    to?: To;
};

function ActivityCenterAuditLink({
    to = '/activity-center/audit',
    children,
    ...rest
}: ActivityCenterAuditLinkProps) {
    return (
        <AppLink to={to} {...rest}>
            {children || 'Activity center'}
        </AppLink>
    );
}
